import { useState } from 'react';
import { managementError } from './managementModel';
import './workgroup-management.css';
export function DisplayNameSettings({
  name: initialName,
  request,
  onSaved,
  onCancel,
}) {
  const [name, setName] = useState(initialName),
    [busy, setBusy] = useState(false),
    [error, setError] = useState('');
  async function save(event) {
    event.preventDefault();
    if (busy || !name.trim()) return;
    setBusy(true);
    setError('');
    try {
      await request('/profile', 'PATCH', { display_name: name.trim() });
      await onSaved(name.trim());
    } catch (cause) {
      setError(managementError(cause));
    } finally {
      setBusy(false);
    }
  }
  return (
    <form
      className="account-editor"
      aria-label="Edit display name"
      onSubmit={(event) => void save(event)}
    >
      <label>
        Display name
        <input
          autoFocus
          maxLength={80}
          value={name}
          disabled={busy}
          onChange={(event) => setName(event.target.value)}
        />
      </label>
      <button type="submit" disabled={busy || !name.trim()}>
        {busy ? 'Saving…' : 'Save'}
      </button>
      <button type="button" disabled={busy} onClick={onCancel}>
        Cancel
      </button>
      {error ? <p role="alert">{error}</p> : null}
    </form>
  );
}
